import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  // Encore une erreur qui se règle seule, soit avec !, soit il ajoute | undefined
  signUpForm!: FormGroup;

  errorMessage! : string;

  constructor(private formBuilder: FormBuilder,
              private authService: AuthService,
              private router: Router) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.signUpForm = this.formBuilder.group({ 
      email: ['', [Validators.required, Validators.email]],
      // Ici le pattern est une expression régulière, il faut minimum 6 caractères, ce qui est la contrainte minimale imposée par Firebase
      password: ['', [Validators.required, Validators.pattern(/[0-9a-zA-Z]{6,}/)]]
    });
  }

  onSubmit() {
    // A mis tout seul ? à get('email')?
    // Si je l'enlève ça met une erreur Object is possibly 'null'. 
    // Lu que je pouvais mettre un ! pour dire que je sais que la valeur ne sera pas nulle
    const email = this.signUpForm.get('email')?.value;
    const password = this.signUpForm.get('password')?.value;
    this.authService.createNewUser(email, password).then(
      () => {
        this.router.navigate(['/books']);
      },
      (error) => {
        this.errorMessage = error;
      }
    )
  }
}
